module.exports = __webpack_public_path__ + "static/media/controller.0d51f514.jpg";